import { Link } from '@solidjs/meta';

export function NunitoSans()
{
	return (<>
		<Link rel='preconnect' href='https://fonts.googleapis.com' />
		<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin='' />
		<Link href='https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap' rel='stylesheet' />
	</>);
}

NunitoSans.fontFamily = '"Nunito Sans", sans-serif';
